import React, {
    useEffect,
    useState,
    useCallback
} from 'react';
import { PolicyService } from 'gw-capability-policy'
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import metadata from './PremiumAuditCEDocumentsTable.metadata.json5';
import styles from './PremiumAuditCEDocumentsTable.module.scss';
import moment from 'moment';
import { GatewayDocumentService } from 'gw-capability-gateway-document';
import { Link } from '@jutro/router';
import PropTypes from 'prop-types';
import { LocalDateUtil } from '@xengage/gw-portals-util-js';

function PremiumAuditCEDocumentsTable(props) {
    const { authHeader, currentAccount } = props;
    const [noDataText, setNoDataText] = useState("Loading...")
    const [documents, setDocuments] = useState([])
    
    const getFormattedDate = useCallback(
        (item, index, property) => {
            return moment(item[property.id]).format('MM/DD/YYYY')
        }, []
    );

    const getDateSorted = useCallback((a, b) => {
        if (!a && !b) return 0;
        if (!a) return 1;
        if (!b) return -1;
        
        return new Date(LocalDateUtil.toMidnightDate(b)) - new Date(LocalDateUtil.toMidnightDate(a));
    }, [])
    
    const getDescription = (item) => {
        const description = item.name;
        return description?.substring(0, description.lastIndexOf('.')) || description;
    }

    const getDownloadLink = useCallback(
        async (item,e) => {
            const { docUID, sessionID } = item;
            try {
                e.preventDefault();
                await GatewayDocumentService.downloadCEDocument(docUID, sessionID);
            } catch (error) {
                setNoDataText('There are no documents available for this account, an error occurred.');
            }
        }, []
    );

    const getDocTypeLink = useCallback(
        (item) => {
           
            const description = item.name;
            
            return (
                <div style={{ textAlign: 'left' }}>
                    <Link
                        icon="mi-insert_drive_file"
                        href="#"
                        onClick={(e)=> getDownloadLink(item,e)}
                    >
                        {description?.substring(description.lastIndexOf('.') + 1, description.length).toUpperCase() || description}
                    </Link>
                </div>
            );
        },
        [getDownloadLink]
    );

    const getPremiumAuditCEDocuments = useCallback(async (accountNumber) => {
        try {
            const auditDocuments = await PolicyService.getPremiumAuditDocsByAccount(accountNumber, authHeader);

            if (auditDocuments == null || auditDocuments.length === 0) {
                setDocuments([]);
                setNoDataText('There are no documents available for this account');
            } else {
                const sortedDocuments = [...auditDocuments].sort((a, b) => {
                    return new Date(b.dateCreated).getTime() - new Date(a.dateCreated).getTime();
                }).reverse();
                setDocuments(sortedDocuments);
            }
        }
        catch (error) {
            setNoDataText('There are no documents available for this account, an error occurred.');
        }
    }, [authHeader]);

    useEffect(() => {
        if (currentAccount && currentAccount?.trim() !== '') {
            getPremiumAuditCEDocuments(currentAccount)
        }
    }, [currentAccount, getPremiumAuditCEDocuments]);

    const overrideProps = {
        PremiumAuditCEDocumentsTable: {
            data: documents,
            noDataText,
            key: currentAccount
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            getFormattedDate,
            getDescription,
            getDocTypeLink,
            getDateSorted
        }
    };

    return (
        <div>
            <MetadataContent uiProps={metadata.pageContent} overrideProps={overrideProps} {...resolvers} />
        </div>
    );
}

PremiumAuditCEDocumentsTable.propTypes = {
    PremiumAuditCEDocuments: PropTypes.arrayOf(PropTypes.string),
};

export default withAuthenticationContext(PremiumAuditCEDocumentsTable);
